import {POLICY_CONSTANTS} from '@/constants/booking';

// Shared content for the "Exclusive Airport Pickup Perks" bar/modal and the
// "Popular questions" FAQ — used by both the booking flow (selectedCarDetailsLatest,
// prebookCompare, the mobile steps) and the trip edit page (RideEdit). Keeping the
// data here lets both surfaces render the same content from one source.

// FAQ data + flow detection live in constants/faqs.js (flow-specific, from docs).

// "Why choose us" perks (the "Exclusive Airport Pickup Perks" modal content).
// `action` opens a nested content view inside the compare modal (booking flow only,
// handled by the parent via onPerkAction) — keyed by the compareView value the perk sets.
export const WHY_PERKS = [
    {icon: "flight-tracking.svg", title: "Flight tracking", sub: "We track your flight and adjust pickup automatically", chevron: true, action: "flight"},
    {icon: "pay-after-dropoff.svg", title: "Pay after drop off", sub: "Square hold funds", chevron: true, action: "payafter"},
    {icon: "cancellation-changes.svg", title: "Cancellation & Changes & Refund", get sub() { return POLICY_CONSTANTS.LOADED ? `Up ${POLICY_CONSTANTS.FREE_CANCELLATION_HOURS} hrs before pickup` : 'Before your scheduled pickup'; }, chevron: true, action: "cancellation"},
    // "Ride now Pay later" (action: "afterpay") removed from the perks list. Its detail view
    // (InterestFreePaymentContent) is still wired in the PERK_VIEWS maps — nothing routes to
    // it now, but leaving it there keeps the perk one line away from coming back.
    {icon: "verified-driver.svg", title: "Verified & insured Drivers", km: "15M+ KM Driven", sub: "Airport transfers delivered by professional partners over 18 years", verified: true},
    {icon: "water-bottle.svg", title: "Complimentary Water", sub: "Refreshing bottled water included"},
    {icon: "oversize-bag.svg", title: "Oversized", sub: "Support for golf bags, bicycles, skis & large items", bags: true},
];
